import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { CaseDocument } from 'src/app/models/case-document';
import { ValidationResult } from 'src/app/models/validation-result';
import { DocumentCategory } from 'src/app/models/document-category';
import { CaseDocumentService } from 'src/app/services/documents.service';
import { Settings } from 'src/app/services/settings';
@Component({
	selector: 'app-addeditdocument',
	templateUrl: './addeditdocument.component.html',
	styleUrls: ['./addeditdocument.component.css']
})
export class AddeditdocumentComponent {

	public isAdd: boolean;
	public caseId: number;

	public valDescription: string;
	public selectedRecord: CaseDocument;
	public valDocument: any;
	public strErr = '';
	public selectedFile: any;
	public valFilePath: any;
	public valDocumentName: any;
	public docCategoryList: Array<DocumentCategory>;
	public docCategory: DocumentCategory;
	public docCategoryId: number;

	public submitEnabled: boolean = false;

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();

	constructor(
		private caseDocumentService: CaseDocumentService
	) {
	}
	onShowHandler(isAdd: boolean, caseId: number, caseDoc: CaseDocument) {
		this.isAdd = isAdd;
		this.caseId = caseId;
		this.submitEnabled = true;
		this.docCategoryList = Settings.getInstance().documentCategoryList.filter(rec => rec.activeStatus == 'Active' && rec.id != Settings.getInstance().AvtarDocumentCategoryId);

		if (isAdd) {
			this.selectedRecord = new CaseDocument();
			this.selectedRecord.caseId = this.caseId;
			this.docCategoryId = -1;
			this.clearFields();
			DwUtils.setFocus('browseId');
		} else {
			this.selectedRecord = new CaseDocument();
			this.selectedRecord.id = caseDoc.id;
			this.selectedRecord.dateAdded = caseDoc.dateAdded;
			this.selectedRecord.documentName = caseDoc.documentName;
			this.selectedRecord.caseId = caseDoc.caseId;
			this.selectedRecord.documentPath = caseDoc.documentPath;
			this.selectedRecord.documentType = caseDoc.documentType;
			this.selectedRecord.readFlag = caseDoc.readFlag;
			this.selectedRecord.addedBy = caseDoc.addedBy;
			this.selectedRecord.documentCategoryId = caseDoc.documentCategoryId;
			this.docCategory = this.docCategoryList.find(rec => rec.id == caseDoc.documentCategoryId);
			this.docCategoryId = caseDoc.documentCategoryId;
			this.displayDetails();
		}
	}
	displayDetails() {
		this.valDescription = this.selectedRecord.documentType;
		this.valDocumentName = this.selectedRecord.documentName;
	}
	clearFields() {
		this.valDescription = '';
		this.valDocumentName = '';
		this.selectedFile = undefined;
	}
	cancelSubmitRecord() {
		this.cancelClicked.emit();
	}

	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		if (this.isAdd && (this.selectedFile === undefined || this.selectedRecord.documentName === undefined || this.selectedRecord.documentName.length === 0)) {
			this.strErr = 'Please select document';
			return false;
		}

		return true;
	}
	submitRecord() {

		this.submitEnabled = false;

		if(this.valDocumentName.length === 0) {
			this.strErr = 'Error: No Document Selected! Please Browse for a document to upload';
			this.submitEnabled = true;
			return;
		}
		if(this.docCategoryId === -1) {
			this.strErr = "Error: Please choose a document category";
			this.submitEnabled = true;
			return;
		}

		if (this.isAdd) {
			this.selectedRecord.documentType = this.docCategoryList.find(rec => rec.id == this.docCategoryId).description;
			this.selectedRecord.documentCategoryId = this.docCategoryId;
			this.selectedRecord.documentName = this.valDocumentName;
			this.selectedRecord.documentPath = this.valDocumentName;
			this.selectedRecord.addedBy = Settings.getInstance().loggedInUser.username;
			this.selectedRecord.readFlag = 0;
			this.selectedRecord.dateAdded = new Date();
			this.selectedRecord.caseId = this.caseId;
		} else {
			this.selectedRecord.documentType = this.docCategoryList.find(rec => rec.id == this.docCategoryId).description;
			this.selectedRecord.documentCategoryId = this.docCategoryId;
		}

		try {
			this.selectedRecord.dateAdded = new Date();
		} catch (Exception) { }

		if (!this.validateFields()) {
			this.submitEnabled = true;
			return;
		}
		if (this.isAdd) {
			this.caseDocumentService.createCaseDocument(this.selectedRecord).subscribe(
				(data) => {
					this.selectedRecord.id = data.id;
					this.caseDocumentService.uploadCaseDocumentFile(this.selectedRecord.id, this.selectedFile).subscribe(
						(data) => {
							this.submitClicked.emit();
						},
						(error) => {
							try {
								this.strErr = 'Error: ' + error['error'].message;
							} catch (Err) {
								this.strErr = 'Error: Unknown error';
							}
							this.submitEnabled = true;
							return;
						}
					);
				},
				(error) => {
					this.submitEnabled = true;
					this.strErr = 'Error: The server could not update this record';
					return;
				});

		} else {
			this.caseDocumentService.updateCaseDocument(this.selectedRecord).subscribe(
				(data) => {
					this.submitClicked.emit();
				},
				(error) => {
					this.submitEnabled = true;
					this.strErr = 'Error: The server could not update this record';
					return;
				});
		}

	}
	fileInputChange(fileInputEvent: any) {
		if (fileInputEvent.target.files[0] === undefined || fileInputEvent.target.files[0] === null) {
			return;
		}
		if (fileInputEvent.target.files[0].size > 500000000) {
			Settings.getInstance().handleError('The image file size should not exceed 5MB');
			return;
		}
		this.selectedFile = fileInputEvent.target.files[0];
		this.valDocumentName = this.selectedFile.name;
	}

}
